<template>
    <div v-if="asientos && asientos.length > 0">
        <h3 class="tw:text-[11px] tw:font-bold tw:uppercase tw:tracking-[0.075em] tw:leading-none tw:text-slate-500">
            {{ $t('perfil.asientos_liberados') }}
        </h3>

        <div class="tw:flex tw:flex-col tw:divide-y tw:divide-slate-100 tw:rounded-md tw:border tw:border-slate-200 tw:overflow-hidden">
            <!-- Cabecera -->
            <div class="tw:grid tw:grid-cols-5 tw:gap-2 tw:p-2 tw:bg-slate-50">
                <span class="tw:col-span-2 tw:text-[10px] tw:font-bold tw:uppercase tw:tracking-[0.075em] tw:text-slate-400">{{ $t('perfil.evento') }}</span>
                <span class="tw:text-[10px] tw:font-bold tw:uppercase tw:tracking-[0.075em] tw:text-slate-400 tw:text-center">{{ $t('perfil.zona') }}</span>
                <span class="tw:text-[10px] tw:font-bold tw:uppercase tw:tracking-[0.075em] tw:text-slate-400 tw:text-center">{{ $t('perfil.fila') }}</span>
                <span class="tw:text-[10px] tw:font-bold tw:uppercase tw:tracking-[0.075em] tw:text-slate-400 tw:text-center">{{ $t('perfil.butaca') }}</span>
            </div>

            <!-- Filas -->
            <div
                v-for="(item, idx) in asientos"
                :key="item.id || idx"
                class="tw:grid tw:grid-cols-5 tw:gap-2 tw:items-center tw:p-2 tw:bg-white tw:hover:bg-slate-50 tw:transition-colors tw:duration-150"
            >
                <!-- Evento -->
                <div class="tw:col-span-2">
                    <p class="tw:text-sm tw:font-semibold tw:text-slate-900 tw:m-0 tw:leading-snug">
                        {{ item.evento_name || '—' }}
                    </p>
                    <p v-if="item.fecha" class="tw:text-xs tw:text-slate-400 tw:m-0 tw:mt-0.5">
                        {{ formatearFecha(item.fecha) || item.fecha }}
                    </p>
                </div>

                <!-- Zona -->
                <span class="tw:text-sm tw:text-slate-700 tw:text-center">
                    {{ item.zona_name || '—' }}
                </span>

                <!-- Fila -->
                <span class="tw:text-sm tw:font-bold tw:text-slate-900 tw:text-center">
                    {{ item.fila || '—' }}
                </span>

                <!-- Butaca -->
                <span class="tw:text-sm tw:font-bold tw:text-slate-900 tw:text-center">
                    {{ item.asiento || '—' }}
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { useFilters } from '@/composables/front/formatters/useFilters';

    defineProps({
        asientos: {
            type: Array,
            default: () => [],
        },
    });

    const { formatearFecha } = useFilters();
</script>
